import { gqlFetchList } from 'app/lib/graphqlClient'
import { logError } from 'lib/logging'

type UsersFetcherResult = {
  hits: { id: string; name: string }[]
  total: number
  page: number
}

/**
 * Fetches workspace users via the GraphQL `users` query.
 * Replaces the deprecated REST endpoint `/api/users/{wid}/staff`.
 *
 * The query is automatically scoped to the authenticated user's org and workspace.
 * Used by UserAssignCell for Contact Owner assignment dropdowns.
 *
 * @param params.query - Search text to filter users by name
 * @param params.workspaceId - Workspace ID to scope results (passed as ES search term)
 * @returns User list with `{ hits, total, page }` shape compatible with ComboAsync optionsMapper
 */
export async function usersFetcher(params: {
  query: string
  workspaceId?: string
  [key: string]: string | undefined
}): Promise<UsersFetcherResult> {
  try {
    const searchTerms = [
      params.query ? `name:*${params.query}*` : undefined,
      params.workspaceId ? `workspaceId.keyword:${params.workspaceId}` : undefined,
      `!type:super`,
    ]
      .filter(Boolean)
      .join(' AND ')

    return await gqlFetchList<{ id: string; name: string }>(
      'users',
      { search: searchTerms || undefined, pagination: { limit: 100 } },
      'id name',
    )
  } catch (err) {
    logError('usersFetcher failed', err)
    return { hits: [], total: 0, page: 0 }
  }
}
